import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getWishListTrackingObj } from '@tcp/core/src/utils/utils.web';
import { setLoyaltyLocation } from '@tcp/core/src/constants/analytics';
import { getCurrentCurrencySymbol } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getCurrencyAttributes } from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import { FavoritesIconNew } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductItemComponents.jsx';
import { getWishListData } from './plpTileHelpers/priceAndWishlistHelper';
import { AddToWishListButton } from './styles/PriceAndWishList.style';
import plpTileLocators from './plpTileLocators';

const checkIsFavorite = (isFavorite) => {
  return isFavorite;
};

const Wishlist = ({
  wishListData,
  productName,
  onAddItemToFavorites,
  onSetLastDeletedItemIdAction,
  productPartNo,
  primaryBrand,
  trackWishListClick,
  isLoggedIn,
  isBundle,
  isPjpTile,
  favAddRemoveLoadingState,
  isSLPTile,
}) => {
  const { isFavorite, wishList } = useMemo(
    () =>
      getWishListData({
        productPartNo,
        wishListData,
        primaryBrand,
      }),
    [productPartNo, wishListData, primaryBrand]
  );

  const addOrRemoveItemToFavorites = () => {
    if (favAddRemoveLoadingState) {
      return;
    }
    const loyaltyLocation = `favorites| ${isSLPTile ? 'SLP' : 'PLP'}}`;
    setLoyaltyLocation(loyaltyLocation);
    const wishListObj = getWishListTrackingObj(loyaltyLocation, isLoggedIn);
    trackWishListClick(wishListObj);
    if (!isFavorite) {
      onAddItemToFavorites({
        colorProductId: productPartNo,
        page: isSLPTile ? 'SLP' : 'PLP',
        products: null,
      });
    } else {
      onSetLastDeletedItemIdAction({
        externalId: wishList?.id,
        productId: productPartNo,
        itemId: wishList.itemId,
        notFromFavoritePage: true,
        wishListName: wishList?.displayName,
      });
    }
  };
  return (
    !isBundle &&
    (isPjpTile ? (
      <AddToWishListButton
        aria-pressed={checkIsFavorite(isFavorite)}
        aria-label={`Add To Favorite ${productName}`}
        onClick={addOrRemoveItemToFavorites}
        data-locator={plpTileLocators.addToFavoritetn}
      >
        <FavoritesIconNew isSolidIcon={isFavorite} />
      </AddToWishListButton>
    ) : (
      <AddToWishListButton isSlp onClick={addOrRemoveItemToFavorites}>
        <FavoritesIconNew isSolidIcon={isFavorite} />
      </AddToWishListButton>
    ))
  );
};

Wishlist.propTypes = {
  wishListData: PropTypes.shape({}),
  onAddItemToFavorites: PropTypes.func.isRequired,
  onSetLastDeletedItemIdAction: PropTypes.func.isRequired,
  productPartNo: PropTypes.string,
  primaryBrand: PropTypes.string,
  currencyAttributes: PropTypes.shape({}),
  trackWishListClick: PropTypes.func,
  isBundle: PropTypes.bool,
  isPjpTile: PropTypes.bool,
  isSLPTile: PropTypes.bool,
};
Wishlist.defaultProps = {
  wishListData: {},
  productPartNo: '',
  primaryBrand: 'tcp',
  currencyAttributes: {},
  trackWishListClick: () => {},
  isBundle: false,
  isPjpTile: false,
  isSLPTile: false,
};

const mapStateToProps = (state) => {
  return {
    currencySymbol: getCurrentCurrencySymbol(state),
    currencyAttributes: getCurrencyAttributes(state),
  };
};

export default connect(mapStateToProps)(Wishlist);
export { Wishlist as WishlistVanilla };
